/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import AssessmentLevelContainer from '../components/assessmentLevel/container/AssessmentLevelContainer';
import LandClassificationsContainer from '../components/classifications/container/LandClassificationsContainer';
import AdjustmentFactorContainer from '../components/adjustmentFactor/container/AdjustmentFactorContainer';
import BuvContainer from '../components/buv/container/BuvContainer';
import PersonOfConcernContainer from '../components/person-of-concerns/container/PersonOfConcernContainer';
import RateContainer from '../components/rates/container/RateContainer';
import DiscountContainer from '../components/discounts/container/DiscountContainer';
import ActualUseContainer from '../components/actual-use/container/ActualUseContainer';
import LandTaxCreditContainer from '../components/tax-credit/containers/LandTaxCreditContainer';
import LandImportCsvContainer from '../components/import-csv/containers/LandImportCsvContainer';

function LandSettingsRoutes({ match, pathName, ordinanceRevisionId }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['E2E RPT LAND SETTINGS ASSESSMENT LEVEL']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/assessment-level"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf(
                        'rpt/land/land-settings/assessment-level'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Assessment Level
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND SETTINGS CLASSIFICATION']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/land-classification"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf(
                        'rpt/land/land-settings/land-classification'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Land Classification
                  </Link>
                </li>
              )}
              {Acl(permissions, [
                'E2E RPT LAND SETTINGS ADJUSTMENT FACTOR',
              ]) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/adjustment-factor"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf(
                        'rpt/land/land-settings/adjustment-factor'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Adjustment Factor
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND SETTINGS BUV']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/buv"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${pathName.indexOf('rpt/land/land-settings/buv') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Basic Unit Values
                  </Link>
                </li>
              )}
              {Acl(permissions, [
                'E2E RPT LAND SETTINGS PERSON OF CONCERN',
              ]) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/person-of-concern"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf(
                        'rpt/land/land-settings/person-of-concern'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Person-of-Concern
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND SETTINGS RATES']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/rates"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/land/land-settings/rates') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Rates
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND SETTINGS DISCOUNTS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/discounts"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/land/land-settings/discounts') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Discounts
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND SETTINGS ACTUAL USE']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/actual-use"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/land/land-settings/actual-use') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Actual Use
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND SETTINGS TAX CREDIT']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/tax-credit"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/land/land-settings/tax-credit') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Tax Credit
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND SETTINGS CSV IMPORT']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings/csv-import"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/land/land-settings/csv-import') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Import CSV
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['E2E RPT LAND SETTINGS ASSESSMENT LEVEL']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/assessment-level`} />}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS ASSESSMENT LEVEL']) && (
            <Route
              path={`${match.path}/assessment-level`}
              render={() => (
                <AssessmentLevelContainer
                  ordinanceRevisionId={ordinanceRevisionId}
                />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS CLASSIFICATION']) && (
            <Route
              path={`${match.path}/land-classification`}
              render={() => (
                <LandClassificationsContainer
                  ordinanceRevisionId={ordinanceRevisionId}
                />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS ADJUSTMENT FACTOR']) && (
            <Route
              path={`${match.path}/adjustment-factor`}
              render={() => (
                <AdjustmentFactorContainer
                  ordinanceRevisionId={ordinanceRevisionId}
                />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS BUV']) && (
            <Route
              path={`${match.path}/buv`}
              render={() => (
                <BuvContainer ordinanceRevisionId={ordinanceRevisionId} />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS PERSON OF CONCERN']) && (
            <Route
              path={`${match.path}/person-of-concern`}
              component={PersonOfConcernContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS PERSON OF CONCERN']) && (
            <Route
              path={`${match.path}/person-of-concern`}
              component={PersonOfConcernContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS RATES']) && (
            <Route
              path={`${match.path}/rates`}
              render={() => (
                <RateContainer ordinanceRevisionId={ordinanceRevisionId} />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS DISCOUNTS']) && (
            <Route
              path={`${match.path}/discounts`}
              component={DiscountContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS ACTUAL USE']) && (
            <Route
              path={`${match.path}/actual-use`}
              component={ActualUseContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS TAX CREDIT']) && (
            <Route
              path={`${match.path}/tax-credit`}
              component={LandTaxCreditContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS CSV IMPORT']) && (
            <Route
              path={`${match.path}/csv-import`}
              component={LandImportCsvContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

LandSettingsRoutes.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(LandSettingsRoutes);
